import { useEffect } from "react";
import { playNotificationSound } from "../lib/notificationSounds";

/**
 * Listen to service-worker postMessage events of type `ihtp-push-sound`
 * (sent by /sw.js when a Web Push arrives) and play a synthesized tone
 * matching the event type.
 *
 * Mounted once at layout level; safely no-ops if Service Worker is
 * unavailable (older browsers, iframes without permission).
 */
export default function usePushSounds() {
  useEffect(() => {
    if (typeof navigator === "undefined" || !("serviceWorker" in navigator)) return undefined;

    const handler = (event) => {
      const data = event?.data;
      if (!data || data.type !== "ihtp-push-sound") return;
      playNotificationSound(data.event_type || "");
    };

    navigator.serviceWorker.addEventListener("message", handler);
    return () => navigator.serviceWorker.removeEventListener("message", handler);
  }, []);
}
